export const applyReadOnly = (form) => form.map((element) => ({ ...element, readOnly: true }));
export const applyDefaultValues = (form, values) => {
  return form.map((element) => ({
    ...element,
    defaultValue: values[element.tag] ? values[element.tag] : undefined,
  }));
};
export const applyDefaultValuesAndReadOnly = (form, values) =>
  applyDefaultValues(applyReadOnly(form), values);
